import PropTypes from 'prop-types'
import { useCallback, useState } from 'react'

import { toastErrorLog } from '../../../helpers/toastErrorLog'
import { insertar } from '../../servicios/mensajesService'
import Input from '../../ui/Input'
import { adjuntoBuilder } from '../upload/adjuntoBuilder'
import { ModalUpload } from '../upload/ModalUpload'
import { Mensaje } from './Mensaje'
import styles from './MensajeriaNew.module.css'

const MAX_PREGUNTAS_VISIBLES = 3

export const MensajeriaNew = ({
  id,
  tipoDoc,
  titulo,
  idVendedor,
  mensajes,
  tipoMensajes,
  usuario,
  actualizarMensajes,
  idComprador
}) => {
  const [texto, setTexto] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [visualizacionPreguntas, setVisualizacionPreguntas] = useState(false)
  const [adjuntosPendientes, setAdjuntosPendientes] = useState([])

  const handleToggle = () => setShowModal((prev) => !prev)

  const handleSubmit = (e) => {
    e.preventDefault()
    if (texto.trim() !== '' || adjuntosPendientes.length > 0) {
      submit()
    }
  }

  const submit = async () => {
    try {
      const mensaje = {
        idMensajePadre: null,
        idUsuarioChat: usuario === idVendedor ? idComprador : idVendedor,
        idComprador,
        idVendedor,
        texto: texto.trim(),
        privado: tipoDoc === 'pedido' || tipoDoc === 'pedidoCabecera',
        IdsAdjuntosList:
          adjuntosPendientes.length > 0
            ? adjuntosPendientes.map((a) => a.idAdjunto)
            : null,
        ...(tipoDoc === 'publicacion'
          ? { idPublicacion: id }
          : tipoDoc === 'pedido'
            ? { idPedidoItem: id }
            : tipoDoc === 'presupuesto'
              ? { idPresupuesto: id }
              : tipoDoc === 'pedidoCabecera'
                ? { idPedido: id }
                : {})
      }

      await insertar(mensaje)
      await actualizarMensajes()
      setTexto('')
      setAdjuntosPendientes([])
    } catch (error) {
      const mensaje = `Ocurrió un error al enviar mensaje.`
      toastErrorLog(error, mensaje, 'mensajeria')
    }
  }

  const manejarAdjunto = useCallback(async (data, setAdjunto, id) => {
    const { dataAdjunto, adjunto } = data
    const previewAdjunto = await adjuntoBuilder(dataAdjunto, adjunto, adjunto.archivo, {
      preview: true
    })

    setAdjunto((prev) => {
      if (prev.some((x) => x.idAdjunto === (adjunto.idAdjunto || id))) {
        return prev
      }
      return [...prev, { ...previewAdjunto, idAdjunto: adjunto.idAdjunto || id }]
    })
  }, [])

  const getFileIcon = (filename) => {
    if (filename.endsWith('.pdf')) {
      return 'fa-file-pdf-o'
    }
    if (filename.endsWith('.doc') || filename.endsWith('.docx')) {
      return 'fa-file-word-o'
    }
    if (filename.endsWith('.xls') || filename.endsWith('.xlsx')) {
      return 'fa-file-excel-o'
    }
    return 'fa-file-o'
  }

  return (
    <div className={styles.contenedorMensajes}>
      <h3>{titulo}</h3>
      <div className="contenedor-msj">
        {mensajes
          .slice(0, tipoMensajes === 'preguntas' ? MAX_PREGUNTAS_VISIBLES : undefined)
          .map((mensaje) => (
            <Mensaje
              key={mensaje.idMensaje}
              mensaje={mensaje}
              usuario={usuario}
              tipoMensajes={tipoMensajes}
              manejarAdjunto={manejarAdjunto}
            />
          ))}
        {mensajes.length > MAX_PREGUNTAS_VISIBLES && tipoMensajes === 'preguntas' && (
          <div className="text-center">
            <button
              className={`btn btn-success ${styles.botonVisualizarPreguntas}`}
              onClick={() => setVisualizacionPreguntas(mensajes.length)}
            >
              Ver más preguntas
            </button>
          </div>
        )}
        {visualizacionPreguntas && (
          <div
            className={`modal fade show d-block ${styles.divVisualizacionPreguntasBlack}`}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Preguntas</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setVisualizacionPreguntas(false)}
                  ></button>
                </div>
                <div className={`modal-body ${styles.divMensajesVisualizacion}`}>
                  {mensajes.map((mensaje) => (
                    <Mensaje
                      key={mensaje.idMensaje}
                      mensaje={mensaje}
                      usuario={usuario}
                      tipoMensajes={tipoMensajes}
                      manejarAdjunto={manejarAdjunto}
                    />
                  ))}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setVisualizacionPreguntas(false)}
                  >
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <form onSubmit={handleSubmit} className={styles.chatForm}>
          {adjuntosPendientes.length > 0 && (
            <div className={styles.adjuntosContainer}>
              {adjuntosPendientes.map((adjunto, index) => (
                <div key={index} className={styles.previewAdjunto}>
                  {adjunto.contentType?.startsWith('image/') ? (
                    <img
                      src={adjunto.url}
                      alt="preview"
                      className={styles.previewImagen}
                    />
                  ) : (
                    <a
                      href={adjunto.url}
                      target="_blank"
                      rel="noreferrer"
                      className={styles.archivoNombre}
                      title={adjunto.nombre}
                    >
                      <i className={`fa ${getFileIcon(adjunto.nombre)}`} />
                      <span className={styles.archivoTexto}>{adjunto.nombre}</span>
                    </a>
                  )}
                  <button
                    type="button"
                    className={styles.removeAdjunto}
                    onClick={() =>
                      setAdjuntosPendientes((prev) => prev.filter((_, i) => i !== index))
                    }
                  >
                    x
                  </button>
                </div>
              ))}
            </div>
          )}

          <div className={styles.inputArea}>
            <span className={styles.attachButton}>
              <i
                aria-hidden="true"
                className="fa fa-paperclip"
                onClick={() => setShowModal(true)}
              />
            </span>

            <Input
              type="text"
              name="texto"
              value={texto}
              onChange={(e) => setTexto(e.target.value)}
              className={styles.input}
              placeholder="Escribí tu pregunta"
            />

            <button
              className={styles.sendButton}
              type="submit"
              disabled={!texto.trim() && adjuntosPendientes.length === 0}
            >
              <i className="fa fa-paper-plane" />
            </button>
          </div>
        </form>
      </div>
      <ModalUpload
        show={showModal}
        onClose={handleToggle}
        idTipo={10}
        idDoc={id}
        idPerfil={usuario}
        onCarga={(data) => manejarAdjunto(data.data, setAdjuntosPendientes)}
      />
    </div>
  )
}

MensajeriaNew.propTypes = {
  id: PropTypes.number.isRequired,
  tipoDoc: PropTypes.string.isRequired,
  titulo: PropTypes.string,
  idVendedor: PropTypes.number.isRequired,
  idComprador: PropTypes.number.isRequired,
  mensajes: PropTypes.arrayOf(PropTypes.object).isRequired,
  tipoMensajes: PropTypes.string,
  usuario: PropTypes.number.isRequired,
  actualizarMensajes: PropTypes.func.isRequired
}
